import { render, staticRenderFns } from "./IconCommoLeave.vue?vue&type=template&id=6c1328b4"
import script from "./IconCommoLeave.vue?vue&type=script&lang=js"
export * from "./IconCommoLeave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports